import { useEffect, useRef, useState } from "react";

export default function CanvasCaptcha({ captcha, setCaptcha }) {
  const canvasRef = useRef(null);

  const generateCaptcha = () => {
    const text = Math.floor(1000 + Math.random() * 9000).toString();
    setCaptcha(text);

    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");

    // Clear canvas
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Background
    ctx.fillStyle = "#911efd";
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // Text
    ctx.font = "22px Arial";
    ctx.fillStyle = "white";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillText(text, canvas.width / 2, canvas.height / 2);
  };

  useEffect(() => {
    generateCaptcha();
  }, []);
  return (
    <div className="captcha-code col col-4">
      <div className="captcha-code-wrapper captcha">
        <canvas
          ref={canvasRef}
          width={68}
          height={35}
          className="captcha-canvas"
        />
      </div>

      <a
        className="refresh"
        onClick={generateCaptcha}
        style={{ cursor: "pointer" }}
      >
        <i
          aria-hidden="true"
          className="v-icon notranslate mdi mdi-refresh theme--light"
        />
      </a>
    </div>
  );
}
